import { erpAxios } from '..';

const editKomitent = async (data) => {
  const { jmbg } = await erpAxios.post(`/komitenti/edit`, data);
  return jmbg ? jmbg : null;
};

export default editKomitent;
